import FavouritesApp from './vue/Favourites.vue';

new Vue({
    el: "#favourites-app",
    name: 'Favourites',
    render: h => h(FavouritesApp),
})



// WEBPACK FOOTER //
// ./scripts/favourites.js